import React, {useEffect, useState} from 'react';
import {message, Select} from 'antd';
import {ReactComponent as SelectArrayIcon} from '../../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../../assets/i/arrow-up-icon.svg';
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {optionsAvailableType} from "components/form/options/options";
import {groupListing} from "features/model/service/create-test/group-listing/groupListing";
import {useAppDispatch, useAppSelector} from "common/hook";
import {studentListing} from "features/model/service/create-test/student-listing/studentListing";
import {
    SelectModeGroup
} from "components/pages/test/test-inner-answer/test-create/select-create/select-create-group/SelectModeGroup";
import {
    SelectModeStudent
} from "components/pages/test/test-inner-answer/test-create/select-create/select-create-student/selectModeStudent";
import {
    setAvailable,
    setGroupIds,
    setStudentsIds,
    setTestName
} from "features/model/slice/create-test/create-test-form/createTestForm";


export const TestCreateSearch = () => {
    const dispatch = useAppDispatch();
    const testFormData = useAppSelector((state) => state.createTestForm);
    const { errors } = useAppSelector((state) => state.responseAddTest);

    const { selectedGroupIds, selectedStudentIds } = testFormData;

    const [openOne, setOpenOne] = useState<boolean>(false);

    const [values, setValues] = useState({
        available: '',
        title: '',
    });

    const { isFilled, handleFocus, handleBlur } = useInputWithFocus([false, false, false, false, false]);

    const [selectedGroupId, setSelectedGroupId] = useState<number[]>([]);
    const [selectedStudentId, setSelectedStudentId] = useState<number[]>([]);



    const onClearGroups = () => {
        setSelectedGroupId([]);
    };

    const onClearStudents = () => {
        setSelectedStudentId([]);
    };

    const handleGroupSelection = (selectedGroupIds: number[]) => {
        setSelectedGroupId(selectedGroupIds);
    };

    const handleStudentSelection = (selectedStudentIds: number[]) => {
        setSelectedStudentId(selectedStudentIds);
    };

    useEffect(() => {
        handleGroupSelection(selectedGroupIds);
        handleStudentSelection(selectedStudentIds);
    }, [selectedStudentIds, selectedGroupIds]);

    useEffect(() => {
        dispatch(groupListing());
        dispatch(studentListing());
    }, [dispatch]);

    useEffect(() => {
        setValues({
            available: testFormData?.available?.toString() || '',
            title: testFormData?.title || '',
        });
    }, [testFormData.available, testFormData.title, selectedGroupIds, selectedStudentIds]);

    const OnClickAvailableHandler = () => {
        setOpenOne(!openOne);
    };

    useEffect(() => {
        const requestData = {
            title: values.title,
            available: values.available,
            selectedGroupId: selectedGroupId,
            selectedStudentId: selectedStudentId,
        };
        dispatch(setTestName(requestData.title));
        dispatch(setAvailable(requestData.available));
        dispatch(setGroupIds(requestData.selectedGroupId));
        dispatch(setStudentsIds(requestData.selectedStudentId));
    }, [values, selectedGroupId, selectedStudentId, dispatch]);

    const handleChange = (name: string, value: string) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };


    return (
        <form className='form'>
            <div className="fields-row two-cols">
                <div className="field large-w">
                    <div
                        style={{width: '100%'}}
                        className={`field ${isFilled[0] ? 'filled' : ''} ${errors?.title ? 'error-field' : ''}`}>
                        <label className={`field-name ${values.title ? 'active-label' : ''}`}>Название теста</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                name="speaking"
                                className="form-control has-icon datepicker"
                                value={values.title}
                                onChange={(event) => handleChange('title', event.target.value)}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                            />
                        </div>
                    </div>
                    {errors?.title && <p className="field-error">{Array.isArray(errors.title) ? errors.title[0] : errors.title}</p>}
                </div>
                <div className="field middle-w">
                    <div className="course-type" onClick={OnClickAvailableHandler}>
                        <span className={values.available ? 'active-label' : ''}>Доступно</span>
                        <Select
                            style={{width: '100%', cursor: 'pointer'}}
                            value={values.available}
                            className="custom-select select-new"
                            onChange={(value) => handleChange('available', value)}
                            options={optionsAvailableType}
                            suffixIcon={openOne ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                            onFocus={() => handleFocus(1)}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
            </div>

            <div className="fields-row two-cols">
                {values.available === '0' && (
                    <>
                        <div className="field has-icon-inp">
                            <p className="field-title">Группы</p>
                            <SelectModeGroup onSelect={handleGroupSelection} onClearGroups={onClearGroups} setSelectedGroupId={setSelectedGroupId}/>
                        </div>
                        <div className="field has-icon-inp">
                            <p className="field-title">Студенты</p>
                            <SelectModeStudent onSelect={handleStudentSelection} onClearStudents={onClearStudents} setSelectedStudentId={setSelectedStudentId}/>
                        </div>
                    </>
                )}
            </div>
        </form>
    );
};